module.exports = __webpack_public_path__ + "fonts/unicredit-regular.92089573.woff";